import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { cannotPurchaseAgain } from "@circle-react/helpers/paywallCheckoutHelpers";
import { Loader } from "@circle-react-uikit/Loader";
import { DefaultFullPreview } from "./DefaultFullPreview";
import { ModalPreview } from "./ModalPreview";

type VARIANT_TYPE = "classical" | "with_modals";

interface PricePreviewProp {
  variant?: VARIANT_TYPE;
}

export const PricePreview = ({ variant = "classical" }: PricePreviewProp) => {
  const { previewMutation, hasAlreadyPurchased, paywall } =
    usePaywallCheckoutContext();
  const { data: preview } = previewMutation;

  if (variant === "with_modals") {
    return <ModalPreview />;
  }

  if (previewMutation.isLoading) {
    return <Loader variant="default" />;
  }

  if (
    cannotPurchaseAgain(hasAlreadyPurchased, paywall) ||
    previewMutation.isIdle ||
    previewMutation.isError ||
    !preview
  ) {
    return null;
  }

  return <DefaultFullPreview preview={preview} />;
};
